export default __webpack_public_path__ + "static/media/partners.6b8c3f33.png";